import { Control, FieldPath, FieldValues, useController } from 'react-hook-form';
import * as Slider from '@givebutter/primitives/slider';
import { FormField } from './FormField';

interface FormSliderProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  description?: string;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export const FormSlider = <T extends FieldValues>({
  name,
  control,
  label,
  description,
  min = 0,
  max = 100,
  step = 1,
  disabled,
}: FormSliderProps<T>) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control });

  const numericValue = Number(value ?? min);

  return (
    <FormField label={label} htmlFor={name} description={description} error={error?.message}>
      <div className="flex items-center gap-2">
        <span className="pl-2 text-sm font-normal">{numericValue}</span>
        <Slider.Root
          value={[numericValue]}
          onValueChange={([v]) => onChange(v)}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
        >
          <Slider.Track>
            <Slider.Range />
          </Slider.Track>
          <Slider.Thumb />
        </Slider.Root>
      </div>
    </FormField>
  );
};
